
  document.addEventListener("DOMContentLoaded", function () {
        const plusSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
<path d="M4.5625 13H22.4375" stroke="#252525" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.5 4.0625V21.9375" stroke="#252525" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const minusSVG = `
 <svg xmlns="http://www.w3.org/2000/svg" width="21" height="2" viewBox="0 0 21 2" fill="none">
<path d="M1.5625 1H19.4375" stroke="#252525" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
    const toggles = document.querySelectorAll('.accordion-toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const item = this.closest('.accordion-item');
        const icon = this.querySelector('.accordion-icon');
        const isOpen = item.classList.contains('open');

        // Close all others if you want only one open at a time
        // document.querySelectorAll('.accordion-item.open').forEach(openItem => {
        //   openItem.classList.remove('open');
        //   openItem.querySelector('.accordion-toggle').setAttribute('aria-expanded', false);
        //   openItem.querySelector('.accordion-icon').textContent = '+';
        // });

        item.classList.toggle('open');
this.setAttribute('aria-expanded', !isOpen);
icon.innerHTML = isOpen ? plusSVG : minusSVG;

      });
    });
  });

